import { call, put } from 'redux-saga/effects';

import * as action from '../../actions';
import * as actNotif from '../../actions/notifications';

import * as api from '../../api/category';
import { assertErrorHasMessage } from '../../utils/assert';

/**
 * Fetch categories from API and return its response
 * Invoke related action if the API fetch result is failed.
 * @returns {*}
 */
export function* getCategories() {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());

  try {
    const response = yield call(api.getCategories);
    return response.data;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    return false;
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.hideProgressBar());
  }
}

/**
 * Fetch categories from API and return its response
 * Invoke related action if the API fetch result is failed.
 * @returns {*}
 */
export function* getCategoriesWithUncategorized() {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());

  try {
    const response = yield call(api.getCategoriesWithUncategorized);
    return response.data;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    return false;
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.hideProgressBar());
  }
}
